
        import * as module0 from '$components/breakpoints.min.js';import * as module1 from '$components/browser.min.js';import * as module2 from '$components/cookies.js';import * as module3 from '$components/demo.js';import * as module4 from '$components/jquery.min.js';import * as module5 from '$components/jquery.scrollex.min.js';import * as module6 from '$components/jquery.scrolly.min.js';import * as module7 from '$components/main.js';import * as module8 from '$components/util.js'
        const modules = {
            "breakpoints.min.js": module0,
            "browser.min.js": module1,
            "cookies.js": module2,
            "demo.js": module3,
            "jquery.min.js": module4,
            "jquery.scrollex.min.js": module5,
            "jquery.scrolly.min.js": module6,
            "main.js": module7,
            "util.js": module8,
        };
        export default modules;
      